<div class="career_sec">
    <div class="banner">
      <img src="../../../../assets/images/career_baneer.jpg" alt="">
    </div>
    <div class="career_content">
      <div class="container">

        <!-- <h2>Exciting opportunities could be coming soon! <br> Stay tuned! </h2> -->
        <div class="filterCategory">
          <button *ngFor="let cat of filterCategory" (click)="getSelectCategory(cat)" class="catBtn" [ngClass]="activeCat === cat ? 'active' : ''">{{cat}}</button>
        </div>
        <div class="grid" *ngIf="jobList.length > 0; else noJobTemplate">
          <mat-card appearance="outlined" *ngFor="let job of jobList">
            <mat-card-header>
              <mat-card-title>
                {{ job.title }}
              </mat-card-title>
              <span  class="role" [ngClass]="getRoleClass(job.category)">
                {{ job.category }}
              </span>
            </mat-card-header>
            <mat-card-content>
              <ng-container *ngIf="job.summary.length <= 200; else truncated">
                <p>{{ job.summary }}</p>
              </ng-container>

              <ng-template #truncated>
                <p>{{ job.summary | slice: 0:120 }}...</p>
              </ng-template>
              <!-- <p>{{ job.summary }}</p> -->
              <span class="experience">
                Min. Experience: {{ job.experience }}
              </span>
            </mat-card-content>
            <mat-card-actions>
              <span class="location">
                <span class="icon_location">
                  <lucide-icon name="MapPin" class="icon_location"></lucide-icon>
                </span>
                {{ job.location }}
              </span>
              <button class="learn_btn" [routerLink]="['/career-detail', job.id]" mat-button>
                Learn More
                <lucide-icon name="ArrowRight" class="arrow"></lucide-icon>
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
        <ng-template #noJobTemplate>
          <div class="no_jobs">
            <h3 class="no_jobs_title">No job openings available in "{{ activeCat }}" at the moment. Please check back later!</h3>
          </div>
        </ng-template>
      </div>
    </div>
  </div>